export default __webpack_public_path__ + "static/media/attendance-red-cross-active.bfb2840d.svg";